import React from "react";
import { ArrowDownIcon, ArrowRightIcon, CheckIcon } from "lucide-react";
import { masterFlow, volumes } from "../../data/content";
import { CtaButton } from "../CtaButton";
export function Volumes() {
  return <section className="bg-cream-100 px-5 py-16 md:py-24" data-id="element-284" data-mp="2x08l6e56fvuf">
      <div className="mx-auto max-w-3xl" data-id="element-285" data-mp="2szom3511mi5n">
        <h2 className="text-center font-serif text-3xl font-bold leading-tight text-navy-950 md:text-5xl" data-id="element-286" data-mp="2syn2gc5yoncb">
          What's inside <em className="text-gold-700" data-id="element-287" data-mp="2o1wj9fyv1bmo">Rhinoplasty MasterMap™</em>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[17px] text-muted" data-id="element-288" data-mp="2j93g2wj1ibcp">
          Six volumes, built in the order you actually reason through a case.
        </p>

        <ol className="mt-12 space-y-5" data-id="element-289" data-mp="29c7fdczdutip">
          {volumes.map(v => <li key={v.number} className="overflow-hidden rounded-3xl bg-white ring-1 ring-cream-200" data-id="element-290" data-mp="25a42cjx2fgvb">
              <div className="flex items-center gap-4 bg-navy-900 px-5 py-4" data-id="element-291" data-mp="20b0ukrppawjn">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-gold-400 font-serif text-lg font-extrabold text-navy-950" data-id="element-292" data-mp="20d3uq4kki623">
                  {v.number}
                </span>
                <div className="min-w-0" data-id="element-293" data-mp="37y72tvzg24i8">
                  <p className="text-xs font-bold uppercase tracking-wider text-gold-300" data-id="element-294" data-mp="2u5zcon2o1bsi">Volume {v.number}</p>
                  <h3 className="font-serif text-xl font-bold leading-tight text-white md:text-2xl" data-id="element-295" data-mp="2y7ckh2pbjp22">{v.title}</h3>
                </div>
              </div>
              <div className="p-5 md:p-7" data-id="element-296" data-mp="3qv8fm2z8p8wq">
                <p className="font-semibold text-navy-800" data-id="element-297" data-mp="3qtxb20xyzx4k">{v.subtitle}</p>
                <p className="mt-2 text-[16px] leading-relaxed text-muted" data-id="element-298" data-mp="3cw8o8nkcefwv">{v.body}</p>

                {v.flow && <div className="mt-5 flex flex-wrap items-center gap-x-1.5 gap-y-2" data-id="element-299" data-mp="3ht7gt1ocyesy">
                    {masterFlow.map((step, i) => <React.Fragment key={step} data-id="element-300" data-mp="21in1ta5vasf1" data-mpi={i}>
                        <span className="rounded-lg bg-navy-100 px-3 py-1.5 text-sm font-bold text-navy-900" data-id="element-301" data-mp="26geq7u7azweh">{step}</span>
                        {i < masterFlow.length - 1 && <ArrowRightIcon className="h-4 w-4 text-gold-700" aria-hidden="true" data-id="element-302" data-mp="c0zk3zk526ux" />}
                      </React.Fragment>)}
                  </div>}

                {"steps" in v && v.steps && <div className="mt-5 flex flex-col items-stretch gap-1.5" data-id="element-303" data-mp="3uc34z8scc1sx">
                    {v.steps.map((step, i) => <React.Fragment key={step} data-id="element-304" data-mp="3pfco4j8pp26g" data-mpi={i}>
                        <div className="rounded-xl bg-navy-900 px-4 py-3 text-center text-[15px] font-bold uppercase tracking-wide text-gold-300" data-id="element-305" data-mp="3kef6q8vj0c60">
                          {step}
                        </div>
                        {i < (v.steps?.length ?? 0) - 1 && <ArrowDownIcon className="mx-auto h-5 w-5 text-gold-700" aria-hidden="true" data-id="element-306" data-mp="3bg38plsbyc3j" />}
                      </React.Fragment>)}
                  </div>}

                {v.bullets.length > 0 && <ul className="mt-5 grid grid-cols-1 gap-x-4 gap-y-2 sm:grid-cols-2" data-id="element-307" data-mp="2rl1yjh67mcmm">
                    {v.bullets.map(b => <li key={b} className="flex items-center gap-2 text-[15px] text-ink" data-id="element-308" data-mp="2wibu7ek6zkiw">
                        <CheckIcon className="h-4 w-4 shrink-0 text-gold-700" strokeWidth={3} aria-hidden="true" data-id="element-309" data-mp="31bmu0vql711b" />
                        {b}
                      </li>)}
                  </ul>}
              </div>
            </li>)}
        </ol>

        <CtaButton className="mt-12" label="I want all 6 volumes" data-id="element-310" data-mp="2dlshyge3dgi4" />
      </div>
    </section>;
}